import './loader.scss'
import PropTypes from "prop-types";

export const Loader = ({show}) => {
    return (
        <>
            {(show) ? <div className="loader-container">
                <div className="loader">Loading...</div>
            </div> : ""}
        </>


    );

}
Loader.propTypes = {
    show: PropTypes.bool.isRequired
}

Loader.defaultProps  = {
    show: false
}

